<script>
    import "../../app.css";

    export let headline = "Default Headline";
    export let subheadline;
    export let image;
    export let imageAlt = "Background";
    export let linkUrl = "";
    export let target = "_blank";
    export let backgroundColor = "";
    export let textColor = "#FFFFFF";
    export let topheadline = "";
    export let fontFamilyTopHeadline = "var(--font-heading)";
    export let fontSizeHeadline;
    export let fontSizeTopHeadline;
    export let colorTopheadline;
</script>

{#if linkUrl.length > 0}
    <a class="container" style="background-color: {backgroundColor}" href={linkUrl} target={target} rel="noopener noreferrer">
        <img src={image} alt={imageAlt} />
        <div class="overlay"></div>

        <div class="column">
            {#if topheadline}
                <p class="top" style="font-family: {fontFamilyTopHeadline};{fontSizeTopHeadline ? 'font-size:' + fontSizeTopHeadline + ';' : ''}{colorTopheadline ? 'color:' + colorTopheadline + ';' : ''}">{topheadline}</p>
            {/if}
            <h3 style="color:{textColor};{fontSizeHeadline ? 'font-size:' + fontSizeHeadline + ';' : ''}">
                {headline}
            </h3>
            {#if subheadline}
            <p style="color:{textColor}">{subheadline}</p>
            {/if}
        </div>
    </a>
{:else}
    <div class="container" style="background-color: {backgroundColor}">
        <img src={image} alt={imageAlt} />
        <div class="overlay"></div>

        <div class="column">
            {#if topheadline}
                <p class="top" style="font-family: {fontFamilyTopHeadline};{fontSizeTopHeadline ? 'font-size:' + fontSizeTopHeadline + ';' : ''}{colorTopheadline ? 'color:' + colorTopheadline + ';' : ''}">{topheadline}</p>
            {/if}
            <h3 style="color:{textColor};{fontSizeHeadline ? 'font-size:' + fontSizeHeadline + ';' : ''}">
                {headline}
            </h3>
            {#if subheadline}
            <p style="color:{textColor}">{subheadline}</p>
            {/if}
        </div>
    </div>
{/if}

<style>
    .container {
        display: block;
        width: 100%;
        height: 550px;
        background: var(--on-surface);
        border-radius: 24px;
        overflow: hidden;
        position: relative;
        padding: 0px;
    }

    .container:hover .overlay, .container:hover .column{
        backdrop-filter: blur(6px);
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6));
        transition: all 0.3s ease-in-out;
    }

    a.container:hover {
        text-decoration: none;
    }
    
    .column {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        position: relative;
        width: 100%;
        height: 100%;
        gap: 8px;
        padding: 24px;
    }

    h3 {
        text-align: left;
        font-family: var(--font-body);
        margin: 0;
        padding: 0;
        font-size: 48px;
    }

    p {
        text-align: left;
        opacity: 0.7;
        font-size: 24px;
        line-height: 1.5;
        letter-spacing: -1px;
        margin: 0;
        padding: 0;
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        mask: linear-gradient(transparent, transparent, transparent, black, black);
        backdrop-filter: blur(4px);
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5));
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        object-position: left;
    }

    p.top {
        font-family: var(--font-heading);
        color: var(--orange);
        font-weight: 500;
        font-size: 32px;
        opacity: 1;
        margin: 0;
    }

    @media (max-width: 768px) {
        .container {
            height: 350px;
        }

        h3 {
            font-size: 32px;
        }

        p {
            font-size: 16px;
            letter-spacing: 0px;
        }

        p.top {
            font-size: 24px;
        }
    }
</style>
